import React from "react";
import Button from "@material-ui/core/Button";
import "./Heading.scss";

function Heading({ ...props }) {
  return (
    <h2 className="Heading">
      {props.title}
      <span>
        {props.button ? (
          <span>
            <Button className={props.className} onClick={props.onClick}>
              {props.titleB}
            </Button>
          </span>
        ) : null}
        {props.buttonNr2 ? (
          <span className="ButtonNr2">
            <Button
              disabled={props.disabled}
              className={
                props.classNameNr2 ? props.classNameNr2 : props.className
              }
              onClick={props.onClick2}
              style={{ marginTop: window.innerWidth < 500 ? "8px" : 0 }}
            >
              {props.titleB2}
            </Button>
          </span>
        ) : null}
      </span>
    </h2>
  );
}

export default Heading;
